<template>
  <div v-shortkey.once="['ctrl', 'alt', 'f']" @shortkey="updateFullScreen">
    <base-dialog
      :show-dialog="showDialog"
      width="1200"
      :scrollable="true"
      :fullscreen="fullscreen"
    >
      <template v-slot:body>
        <v-card>
          <v-card-title class="mt-0 p-0" style="height: 65px">
            <v-row dense>
              <v-col cols="4">
                <v-text-field
                  placeholder="Consulte pela Descrição ou Código do item"
                  label="Descrição ou Código"
                  class="text-caption ml-1"
                  v-model="searchItens.codigo"
                  @input="searchItem()"
                  @focusin="focused = !focused"
                  @focusout="focused = !focused"
                  outlined
                  dense
                />
              </v-col>
              <v-col cols="3" sm="3" md="3" lg="3">
                <div>
                  <c-select
                    class="text-caption ml-1"
                    rotulo="Fabricantes"
                    itemText="text"
                    itemValue="value"
                    :lista="cbManufacturerList"
                    v-model="searchItens.fabricante"
                    @input="searchItem()"
                    @focusin="focused = !focused"
                    @focusout="focused = !focused"
                    :dark="false"
                  />
                  <!-- <v-combobox dark :items="cbManufacturerList" dense hint="Fabricantes" persistent-hint @change="changeFabricante($event)" :value="itemQuery.fabricante"/> -->
                </div>
              </v-col>
              <v-col cols="1" sm="2" md="2" lg="2">
                <div>
                  <c-select
                    class="text-caption ml-1"
                    rotulo="Marcas"
                    itemText="text"
                    itemValue="value"
                    :lista="cbBrandList"
                    v-model="searchItens.marca"
                    @input="searchItem()"
                    @focusin="focused = !focused"
                    @focusout="focused = !focused"
                    :dark="false"
                  />
                  <!-- <v-combobox dark :items="cbBrandList" dense hint="Marcas" persistent-hint @change="changeMarca($event)" :value="itemQuery.marca"/> -->
                </div>
              </v-col>
              <v-col cols="1" sm="1" md="1" lg="1">
                <c-select
                  class="text-caption ml-1"
                  item-text="cifrao"
                  item-value="index"
                  rotulo="Moeda"
                  :clearable="false"
                  v-model="indexMoeda"
                  :lista="currenciesList"
                  :item.sync="getDadosMoeda"
                  @focusin="focused = !focused"
                  @focusout="focused = !focused"
                  :dark="false"
                  @input="updateCurrency($event)"
                />
              </v-col>
              <v-col cols="2">
                <c-select
                  class="text-caption ml-1"
                  rotulo="Tipo preço"
                  itemText="text"
                  itemValue="value"
                  :clearable="false"
                  :lista="priceTypes"
                  :item.sync="priceTypes[indexPriceTypes]"
                  v-model="tipoPreco"
                  :disabled="
                    isGuest ||
                      !!getFlagSetado('AssumeTipoPrecoSoDoCadastroEmpresas')
                  "
                  @input="getDados()"
                  @focusin="focused = !focused"
                  @focusout="focused = !focused"
                  :dark="false"
                />
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="cardText">
            <v-row no-gutters class="cardTextRowTable">
              <v-col cols="12">
                <v-data-table
                  dense
                  dark
                  hide-default-footer
                  :loading="loadingItems"
                  loading-text="Carregando itens... "
                  :items="itemListComputed"
                  :headers="listHeader"
                  item-key="CODIGO"
                  :item-class="estilizaLinha"
                  @click:row="clickLine($event)"
                  @update:sort-by="getLinhasTabela"
                  @current-items="setCurrentList"
                  :single-expand="false"
                  :expanded.sync="expanded"
                  :show-expand="true"
                  :items-per-page="itensTable"
                  :fixed-header="true"
                  :height="heightTable"
                  show-select
                  id="tabelaItens"
                  v-model="selected"
                  @toggle-select-all="selectAllToggle"
                  :search="search"
                  :custom-filter="filterOnTable"
                >
                  <template v-slot:top>
                    <v-container fluid>
                      <v-text-field
                        v-model="search"
                        class="mt-6"
                        label="Filtrar na tabela"
                        dense
                        prepend-inner-icon="mdi-magnify"
                        single-line
                        hide-details
                      ></v-text-field>
                    </v-container>
                  </template>

                  <template
                    v-slot:item.data-table-select="{ item, isSelected, select }"
                  >
                    <v-simple-checkbox
                      :ripple="false"
                      :value="isSelected"
                      :readonly="item.disableSelect"
                      :disabled="item.disableSelect"
                      @input="select($event)"
                    ></v-simple-checkbox>
                  </template>
                  <template v-slot:expanded-item="{ headers, item }" dense>
                    <td :colspan="headers.length" dense>
                      <v-row dense class="mt-1">
                        <v-col cols="2" dense>
                          <c-input
                            :label="'Quantidade'"
                            :placeholder="'Quantidade'"
                            :maxLength="5"
                            v-model="item.quantidade"
                            :type="'number'"
                            min="1"
                            step="1"
                            :disabled="item.disableSelect"
                            :id="item.CODIGO"
                            :isRequired="false"
                            @input="updateQnt(item, $event)"
                            @click="setIndexRowExpandedSelected(0)"
                            class="text-caption ml-1"
                            hide-details="auto"
                          />
                        </v-col>
                        <v-col cols="6">
                          <span class="text-caption">
                            Qtde no orçamento:
                            {{ getDadosItem(item).quantidade }}
                            &nbsp;&nbsp;&nbsp; (Total item
                            {{
                              formatCurrency(
                                getDadosItem(item).indexMoeda0,
                                getDadosItem(item).totalItem
                              )
                            }}
                            )
                          </span>
                        </v-col>
                      </v-row>
                    </td>
                  </template>
                  <template v-slot:item.PRECOITEM="{ item }">
                    <v-chip :color="getColor(item.EMOFERTA)" dark small>
                      {{
                        formatCurrency(
                          moeda,
                          item.PRECOITEM[currenciesList[moeda].cifrao]
                        )
                      }}
                    </v-chip>
                  </template>
                  <template v-slot:item.pin="{ item }">
                    <span v-if="!item.disableSelect">
                      <v-btn-toggle tile>
                        <v-btn
                          fab
                          color="warning"
                          x-small
                          @click="pinObject(item)"
                        >
                          <v-icon color="white">mdi-pin-outline</v-icon>
                        </v-btn>
                      </v-btn-toggle>
                    </span>
                    <span v-else>
                      <v-tooltip top>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn-toggle tile>
                            <v-btn
                              v-on="on"
                              v-bind="attrs"
                              fab
                              color="red"
                              x-small
                            >
                              <v-icon>mdi-comment-question</v-icon>
                            </v-btn>
                          </v-btn-toggle>
                        </template>
                        <span
                          >Bloqueado Item {{ item.CODIGO }} com preço zero!
                        </span>
                      </v-tooltip>
                    </span>
                  </template>
                  <template v-slot:item.imagens.image_name="{ item }">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <span v-if="item.imagens">
                          <v-btn
                            v-on="on"
                            v-bind="attrs"
                            x-small
                            @click="toogleOverlay(item)"
                          >
                            <v-icon color="blue">mdi-image-outline</v-icon>
                          </v-btn>
                        </span>
                        <span v-else>
                          <v-btn v-on="on" v-bind="attrs" x-small>
                            <span class="red--text">X</span>
                          </v-btn>
                        </span>
                      </template>
                      <span v-if="item.imagens">Visualizar Imagem do Item</span>
                      <span v-else>Sem Imagem</span>
                    </v-tooltip>
                  </template>
                  <template v-slot:item.SALDOITEM="{ item }">
                    <div class="text-caption">
                      {{
                        item.SALDOITEM - parseInt(item.SALDOITEM, 10) > 0
                          ? formatDecimal(item.SALDOITEM, 4, 2)
                          : formatDecimal(item.SALDOITEM, 0, 0)
                      }}
                    </div>
                  </template>
                  <template v-slot:item.DESCRICAO="{ item }">
                    <div class="text-caption">
                      {{ item.DESCRICAO }}
                    </div>
                  </template>
                  <template v-slot:item.MARCA="{ item }">
                    <div class="text-caption">
                      {{ item.MARCA }}
                    </div>
                  </template>
                  <template v-slot:item.CODIGO="{ item }">
                    <div class="text-caption" id="COLUNACODIGO">
                      {{ item.CODIGO }}
                    </div>
                  </template>
                  <template v-slot:item.UM="{ item }">
                    <div class="text-caption">
                      {{ item.UM }}
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
            <v-row dense no-gutters class="cardRowRodape">
              <v-col cols="12">
                <v-card
                  v-if="
                    $vuetify.breakpoint.name == 'sm' ||
                    $vuetify.breakpoint.name == 'md'
                      ? true
                      : false
                  "
                  dense
                  class="rounded-bl-xl text-center mt-1"
                  color="secondary"
                  dark
                  :min-width="500"
                  :min-height="50"
                >
                  <v-card-text>
                    <v-row dense>
                      <span
                        v-for="(item, index) in dadosRodape"
                        :key="index"
                        class="white--text"
                      >
                        <span class="font-weight-black">
                          {{ item.CODIGO }}
                        </span>
                        <span v-if="item.saldosDepartamentos.length > 0">
                          | Dptos:
                          <span
                            v-for="i in item.saldosDepartamentos"
                            :key="i.DESCRICAO"
                          >
                            <v-chip dark small>
                              {{ i.DESCRICAO }}:
                              {{ parseFloat(i.SALDODEPARTAMENTO) }}
                            </v-chip>
                          </span>
                        </span>
                        <!--
              <span>
                 <v-chip dark> Geral: {{ item.SALDOITEM }} </v-chip> 
              </span>
                 -->
                        <span v-if="item.saldosFiliais.length > 0">
                          | Filiais:
                          <span
                            v-for="it in item.saldosFiliais"
                            :key="it.FILIAL"
                          >
                            <v-chip dark small>
                              {{ it.FILIAL }} | {{ parseFloat(it.SALDOITEM) }}
                            </v-chip>
                          </span>
                        </span>
                      </span>
                    </v-row>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn
              dark
              color="red darken-4"
              class="text-subtitle-2 ml-1 px-1 py-1"
              @click="$emit('close')"
            >
              <span>Fechar</span>
            </v-btn>
            <v-btn
              dark
              color="green darken-4"
              class="text-subtitle-2 ml-1 px-1 py-1"
              @click="addItens"
              v-if="selected.length > 0"
            >
              <v-icon small>
                mdi-cart-arrow-down
              </v-icon>
              <span class="text-overline"
                >Adicionar Itens ({{ selected.length }})</span
              >
            </v-btn>
            <v-spacer></v-spacer>
            <span>
              <v-chip dark>
                <span> {{ itemList.length }}/{{ pagination.total }}</span>
              </v-chip>
            </span>
            <v-btn-toggle
              v-if="
                $vuetify.breakpoint.name == 'sm' ||
                $vuetify.breakpoint.name == 'md'
                  ? true
                  : false
              "
              dark
              rounded
              active-class="{}"
            >
              <v-btn @click="configuraLinha({ code: 'ArrowLeft' })">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
              <v-btn @click="configuraLinha({ code: 'ArrowUp' })">
                <v-icon>mdi-arrow-up</v-icon>
              </v-btn>
              <v-btn @click="configuraLinha({ code: 'ArrowDown' })">
                <v-icon>mdi-arrow-down</v-icon>
              </v-btn>
              <v-btn @click="configuraLinha({ code: 'ArrowRight' })">
                <v-icon>mdi-arrow-right</v-icon>
              </v-btn>
              <v-btn @click="configuraLinha({ code: 'Space' })">
                <span>Selecionar</span>
              </v-btn>
            </v-btn-toggle>
            <v-card
              v-else-if="dadosRodape.length > 0"
              class="rounded-bl-xl text-center"
              color="secondary"
              dark
              :min-width="500"
              :min-height="50"
            >
              <v-card-text>
                <v-row dense>
                  <span
                    v-for="(item, index) in dadosRodape"
                    :key="index"
                    class="white--text"
                  >
                    <span class="font-weight-black"> {{ item.CODIGO }} </span>
                    <span v-if="item.saldosDepartamentos.length > 0">
                      | Dptos:
                      <span
                        v-for="i in item.saldosDepartamentos"
                        :key="i.DESCRICAO"
                      >
                        <v-chip dark small>
                          {{ i.DESCRICAO }}:
                          {{ parseFloat(i.SALDODEPARTAMENTO) }}
                        </v-chip>
                      </span>
                    </span>
                    <!--
              <span>
                 <v-chip dark> Geral: {{ item.SALDOITEM }} </v-chip> 
              </span>
                 -->
                    <span v-if="item.saldosFiliais.length > 0">
                      | Filiais:
                      <span v-for="it in item.saldosFiliais" :key="it.FILIAL">
                        <v-chip dark small>
                          {{ it.FILIAL }} | {{ parseFloat(it.SALDOITEM) }}
                        </v-chip>
                      </span>
                    </span>
                  </span>
                </v-row>
              </v-card-text>
            </v-card>
          </v-card-actions>
          <!-- Imagem overlay Component-->
          <overlayItem
            :isVisible="overlay.overlay"
            :isAbsolute="overlay.absolute"
            :imagesList="imagesList"
            :especificacoes="overlay.especificacoes"
            :item="overlay.item"
            :opacity="0.8"
            v-model="overlay.model"
            @closeOverlay="closeOverlay"
          />
        </v-card>
      </template>
    </base-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import baseDialog from '@/components/shared/base-dialog/BaseDialog'
import { currencyMixin } from '@/mixins/object/currency/CurrencyMixin'
import { flagsMixin } from '@/mixins/object/flags/FlagsMixin'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect'
import overlayItem from '@/components/shared/base-overlay/BaseOverlay'

export default {
  mixins: [currencyMixin, flagsMixin],
  components: { baseDialog, cInput, cSelect, overlayItem },
  computed: {
    itemListComputed() {
      const r = this.itemList.map((item) => ({
        ...item,
        disableSelect:
          item.PRECOITEM[this.currenciesList[this.moeda].cifrao] > 0 ||
          !this.getFlagSetado('BloqueiaPrecoZeroNoOrcamento')
            ? false
            : true,
      }))
      return r
    },
    positionSelectedLine() {
      return this.rowSelected ? this.rowSelected.offsetTop : undefined
    },
    // Ver o breakpoint da página
    heightTable() {
      let breakpointName = this.$vuetify.breakpoint.name
      let size = this.updateHeightTable(breakpointName)
      return size ?? 450
    },
    // Item Module
    ...mapState('itemModule', ['itemList', 'loadingItems', 'pagination']),
    ...mapState('pdvBalcaoModule/orderModule', ['order']),
    ...mapState('pdvBalcaoModule/orderItensModule', ['orderItens']),
    //System Module
    ...mapGetters({
      currenciesList: 'systemModule/getSystemCurrencies',
      cbManufacturerList: 'manufacturerModule/getCbList',
      cbBrandList: 'brandModule/getCbList',
    }),
    listHeader() {
      return [
        { text: '', value: 'data-table-expand' },
        {
          text: 'Código',
          value: 'CODIGO',
        },
        {
          text: 'UM',
          value: 'UM',
        },
        {
          text: 'Descrição',
          value: 'DESCRICAO',
        },
        {
          text: 'Marca',
          value: 'MARCA',
        },
        {
          text: 'Preço',
          value: 'PRECOITEM',
        },
        { text: 'Imagem', value: 'imagens.image_name' },
        { text: 'Saldo', value: 'SALDOITEM' },
        {
          text: 'Ações',
          value: 'pin',
          align: 'right',
        },
      ]
    },
    indexPriceTypes() {
      let index
      switch (this.tipoPreco) {
        case 'PRECOVAREJO':
          index = 0
          break
        case 'PRECOATACADO':
          index = 1
          break
        case 'PRECOESPECIAL':
          index = 2
          break
        case 'PRECOESPECIAL2':
          index = 3
          break
        case 'PRECOESPECIAL3':
          index = 4
          break
        default:
          index = 0
          break
      }
      return index
    },
    priceTypes() {
      let defaultList = [
        { text: 'Preço Varejo', value: 'PRECOVAREJO' },
        { text: 'Preço Atacado', value: 'PRECOATACADO' },
        { text: 'Preço Especial', value: 'PRECOESPECIAL' },
      ]
      if (this.getFlagSetado('PrecoEspecial23')) {
        let special23List = [
          { text: 'Preço Especial 2', value: 'PRECOESPECIAL2' },
          { text: 'Preço Especial 3', value: 'PRECOESPECIAL3' },
        ]
        // concatena duas listas
        Array.prototype.push.apply(defaultList, special23List)
      }
      return defaultList
    },
    getDadosMoeda: {
      get() {
        return this.currenciesList.filter((e) => e.index == this.order.moeda)[0]
      },
      set() {
        this.indexMoeda = this.currenciesList.filter((e) => {
          if (e.index == this.order.moeda) {
            this.indexMoeda = e.index
          }
        })
      },
    },
  },
  data: () => {
    return {
      focused: false,
      fullscreen: false,
      search: '',
      currentList: [],
      searching: false,
      page: 1,
      itensTable: 30,
      disabledCount: 0, // quantidade de linhas não selecionaveis na tabela
      selected: [],
      dadosRodape: [],
      expanded: [],
      tipoPreco: '',
      moeda: 0,
      indexMoeda: 0,
      timer: null,
      timerScroll: null,
      searchItens: {
        marca: '',
        fabricante: '',
        codigo: '',
      },
      overlay: {
        overlay: false,
        cycle: false,
        absolute: false,
        color: 'dark',
        model: 0,
        especificacoes: '',
        item: {},
      },
      imagesList: [],
      elementoTableWraper: [],
      //Linha selecionada
      rowSelected: [],
      //Linha expandida selecionada
      rowExpandedSelected: [],
      //Linhas da tabela
      rows: [],
      //Linhas expandidas da tabela
      rowsExpanded: [],
      indexRowSelected: -1,
      indexRowExpandedSelected: -1,
    }
  },
  created() {
    const self = this
    this.itemListComputed.map((item) => {
      if (item.disableSelect) self.disabledCount += 1
    })
  },
  async mounted() {
    try {
      this.addEventos()
      // setar nas propriedades locais, não alterar estado do orçamento
      this.tipoPreco = this.order.tipoPreco
      this.moeda = this.order.moeda
      if (this.cbBrandList.length <= 0) await this.getBrandsAPI({ todos: 'S' })
      if (this.cbManufacturerList.length <= 0)
        await this.getManufacturersAPI({ todos: 'S' })
      await this.getDados()

      // para marcar a primeira linha da tabela ou em uma eventua linha ja selecionada
      this.goToTableTop(0, this.indexRowSelected)
    } catch (error) {
      this.$toasted.error(error, { duration: null })
    }
  },
  destroyed() {
    document.removeEventListener('scroll', this.handleScroll)
    document.removeEventListener('keydown', this.configuraLinha)
    document.removeEventListener('keyup', this.configuraLinhaKeyUp)
  },
  methods: {
    filterOnTable(value, search) {
      return (
        value != null &&
        search != null &&
        typeof value === 'string' &&
        value
          .toString()
          .toLocaleUpperCase()
          .indexOf(search.toLocaleUpperCase()) !== -1
      )
    },
    setCurrentList(value) {
      this.currentList = value ?? []
    },
    estilizaLinha(item) {
      let estiloLinha = 'linhaTabela'
      if (item.DESTAQUECOR) {
        estiloLinha += ' yellow--text' // trazer informação da cor do item
      } else if (this.getFlagSetado('ItemSaldoMinimoEmVermelho')) {
        if (parseFloat(item.SALDOITEM) <= parseFloat(item.SALDOMINIMO) ?? 0)
          estiloLinha += ' red--text font-weight-black'
      }

      return estiloLinha
    },
    ...mapActions({
      getItemsAPI: 'itemModule/getItens',
      addOrderItem: 'pdvBalcaoModule/orderItensModule/addOrderItem',
      getBrandsAPI: 'brandModule/getBrands',
      getManufacturersAPI: 'manufacturerModule/getManufacturers',
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setLoadingDialogMessage: 'dialogModule/setLoadingDialogMessage',
    }),
    addEventos() {
      try {
        // Captura a tabela de itens para e adiciona o evento de scroll
        let tabelaItens = document.getElementById('tabelaItens')

        this.elementoTableWraper = tabelaItens
          ? tabelaItens.getElementsByClassName('v-data-table__wrapper')
          : null
        if (this.elementoTableWraper && this.elementoTableWraper[0]) {
          this.elementoTableWraper[0].addEventListener(
            'scroll',
            this.handleScroll
          )
          // Captura as linhas da tabela de itens e adiciona o evento keydown
          this.getLinhasTabela()
        }

        document.addEventListener('keydown', this.configuraLinha, false)
        document.addEventListener('keyup', this.configuraLinhaKeyUp, false)
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },

    // Captura as linhas da tabela de itens e adiciona o evento keydown
    async getLinhasTabela() {
      try {
        await this.desmarcaLinha()
        await this.$nextTick()

        this.rows = this.elementoTableWraper[0]
          .getElementsByTagName('table')[0]
          .getElementsByTagName('tbody')[0]
          .getElementsByClassName('linhaTabela')

        await this.goToTableTop()
        await this.$nextTick()

        /* 
        Deve ser verificado currentList para não dar erro ao carregar
        Trecho abaixo é necessário ao fazer o sort nas colunas e buscar o saldo do item focado
      */
        if (this.currentList.length > 0) {
          this.updateRodapeSelect()
        }
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    arrowUp() {
      try {
        if (this.indexRowExpandedSelected > -1) return
        // this.arrowLeft()

        if (this.indexRowSelected > -1) {
          let newIndex = parseInt(this.indexRowSelected) - parseInt(1)
          this.setIndexRowSelected(newIndex)
          let pos = this.rowSelected.getBoundingClientRect()

          if (
            this.rowSelected.offsetTop <
            this.elementoTableWraper[0].scrollTop + pos.height
          )
            this.goTo(pos.height, 'up')
          if (newIndex == 0) this.rowSelected.scrollIntoView(false)
        } else this.goToTableTop()
      } catch (error) {
        console.error('Error...')
      }
    },
    arrowDown() {
      try {
        if (this.indexRowExpandedSelected > -1) return

        if (this.indexRowSelected < this.rows.length - 1) {
          let newIndex = parseInt(this.indexRowSelected) + parseInt(1)
          this.setIndexRowSelected(newIndex)
          let pos = this.rowSelected.getBoundingClientRect()
          if (pos.top > this.elementoTableWraper[0].clientHeight)
            this.goTo(pos.height, 'down')
        }
      } catch (error) {
        console.error('Error...')
      }
    },
    arrowLeft() {
      let indexItemExpanded = this.getItemRowExpandedSelected().index
      if (indexItemExpanded > -1) this.expanded.splice(indexItemExpanded, 1)
      this.cleanRowExpandedSelected()
      let index = this.getItemRowSelected().index
      this.setIndexRowSelected(index)
    },
    arrowRight() {
      let item = this.getItemRowSelected().item
      if (item) {
        let itemExiste = this.expanded.filter(
          (ele) => ele.CODIGO == item.CODIGO
        )
        if (itemExiste.length == 0) {
          this.expanded.push(item)
        } else {
          //Item já expandido
          let indexItemExpanded = this.getItemRowExpandedSelected().index
          this.setIndexRowExpandedSelected(indexItemExpanded)
          let elementoQuantidade = document.getElementById(item.CODIGO)
          elementoQuantidade.focus()
        }
      }
      this.setIndexRowSelected(this.indexRowSelected)
      this.updateRowsExpanded()
    },
    space() {
      let codigoItem = this.getCodigoItemRowSelected()
      let item = this.itemListComputed.filter((c) => c.CODIGO == codigoItem)
      if (item.length > 0 && !item[0].disableSelect) {
        let itemSelecionado = this.selected.filter(
          (e) => e.CODIGO == item[0].CODIGO
        )
        if (itemSelecionado.length > 0) this.desmarcaItemSelected(item[0])
        else {
          let i = this.itemListComputed.filter(
            (e) => e.CODIGO == item[0].CODIGO
          )
          if (!i[0].disableSelect) this.selectItem(item[0])
        }
      }
      this.arrowDown()
    },
    enter() {
      this.arrowLeft()
      this.arrowDown()
    },
    goToTableTop(coordinate = 0, indexLine = 0) {
      this.elementoTableWraper[0].scrollTop = coordinate
      // this.desmarcaLinha()
      this.$nextTick(function() {
        this.setIndexRowSelected(indexLine)
      })
    },

    configuraLinhaKeyUp: function(event) {
      if (this.focused) return

      const keys = ['Home', 'End', 'PageDown', 'PageUp']
      const { code, ctrlKey } = event

      if (keys.lastIndexOf(code) == -1) return

      let nextLine = 0
      let altura = 0

      const {
        scrollTop,
        scrollHeight,
        clientHeight,
      } = this.elementoTableWraper[0]

      const endScroll = scrollHeight - Math.abs(scrollTop) === clientHeight

      let alignTo = {
        behavior: 'smooth',
        block: 'center',
        inline: 'nearest',
      }

      switch (code) {
        case 'Home':
          if (!ctrlKey) return
          this.goToTableTop()
          break

        case 'PageUp':
          altura = this.positionSelectedLine - clientHeight

          for (let index = this.indexRowSelected; index >= 0; index--) {
            const position = this.rows[index].offsetTop
            nextLine = index
            if (position < altura) {
              break
            }
          }

          this.goToTableTop(altura, nextLine)
          this.$nextTick(function() {
            this.rowSelected.scrollIntoView(alignTo)
          })
          break

        case 'End':
          if (!ctrlKey) return
          nextLine = this.rows ? this.rows.length - 1 : 0
          this.goToTableTop(scrollHeight, nextLine)
          break

        case 'PageDown':
          altura = this.positionSelectedLine + clientHeight

          for (
            let index = this.indexRowSelected + 1;
            index < this.rows.length;
            index++
          ) {
            const position = this.rows[index].offsetTop
            nextLine = index
            if (position > altura) {
              break
            }
          }
          if (nextLine > 0) {
            this.goToTableTop(altura, nextLine)

            if (this.positionSelectedLine > 0 && !endScroll) {
              this.$nextTick(function() {
                this.rowSelected.scrollIntoView(alignTo)
              })
            } else if (endScroll) {
              alignTo.block = 'end'
              this.$nextTick(function() {
                this.rowSelected.scrollIntoView(alignTo)
              })
            }
          }
          break

        default:
          break
      }
      this.$nextTick(function() {
        this.updateRodapeSelect()
      })
    },

    configuraLinha: function(event) {
      if (this.focused) return

      // não prosseguir com alguma dessas teclas pressionadas
      if (event.ctrlKey || event.altKey || event.shiftKey) return

      const teclas = [
        'ArrowUp',
        'ArrowDown',
        'Space',
        'ArrowRight',
        'ArrowLeft',
        'Enter',
        'NumpadEnter',
      ]
      const teclaPressionada = {
        ArrowUp: this.arrowUp,
        ArrowDown: this.arrowDown,
        ArrowRight: this.arrowRight,
        ArrowLeft: this.arrowLeft,
        Space: this.space,
        Enter: this.enter,
        NumpadEnter: this.enter,
      }

      let p = teclas.filter((e) => e == event.code)

      if (p.length > 0) {
        // this.desmarcaLinha()
        teclaPressionada[p]()
        this.$nextTick(function() {
          this.updateRodapeSelect()
        })
      }
    },

    updateRowsExpanded() {
      this.rowsExpanded = this.elementoTableWraper[0]
        .getElementsByTagName('table')[0]
        .getElementsByTagName('tbody')[0]
        .getElementsByClassName('v-data-table__expanded__content')
    },
    getItemRowExpandedSelected() {
      let codigoItem = this.getCodigoItemRowSelected()
      let retorno = {}
      this.expanded.filter((e, index) => {
        if (e.CODIGO == codigoItem) {
          retorno.item = e
          retorno.index = index
        }
      })
      return retorno
    },
    getRowExpanded() {},
    goTo(coordinate, type = 'up') {
      type == 'down'
        ? (this.elementoTableWraper[0].scrollTop += coordinate)
        : (this.elementoTableWraper[0].scrollTop -= coordinate)
    },
    setIndexRowSelected(index) {
      this.desmarcaLinha()

      if (index == -1) this.indexRowSelected = 0
      else this.indexRowSelected = index

      this.rowSelected = this.rows[this.indexRowSelected]

      this.$nextTick(function() {
        this.marcaLinha()
      })
    },
    setIndexRowExpandedSelected(index) {
      this.indexRowExpandedSelected = index
      this.setRowExpandedSelected()
    },
    setRowExpandedSelected() {
      if (this.indexRowExpandedSelected == -1) this.indexRowExpandedSelected = 0
      this.rowExpandedSelected = this.rowsExpanded[
        this.indexRowExpandedSelected
      ]
      // this.marcaLinha()
    },
    cleanRowExpandedSelected() {
      // this.desmarcaLinha('linhaExpanded');
      this.rowExpandedSelected = []
      this.indexRowExpandedSelected = -1
    },
    getCodigoItemRowSelected() {
      try {
        let codigoItem = this.rowSelected
          .getElementsByTagName('td')[2]
          .getElementsByTagName('div')[0].innerText
        return codigoItem
      } catch (error) {
        console.error('Error....')
      }
    },
    getItemRowSelected() {
      let codigoItem = this.getCodigoItemRowSelected()
      let retorno = {}
      this.currentList.filter((c, index) => {
        if (c.CODIGO == codigoItem) {
          retorno.item = c
          retorno.index = index
        }
      })
      return retorno
    },
    marcaLinha(type = 'linhaItem') {
      this.$nextTick(function() {
        let elemento =
          type == 'linhaItem' ? this.rowSelected : this.rowExpandedSelected
        if (elemento) elemento.classList.add('focused-line')
      })
    },
    desmarcaLinha(type = 'linhaItem') {
      let elemento =
        type == 'linhaItem'
          ? this.rows[this.indexRowSelected]
          : this.rowsExpanded[this.indexRowExpandedSelected]
      if (elemento) elemento.classList.remove('focused-line')
    },
    handleScroll: function(e) {
      this.scrollTable(e)
      // /*
      //       e.target.scrollHeight é o altura total da página com a parte scrollable
      //       e.target.scrollTop é o total que já foi realizado o scrool até o top da página
      //       e.target.clientHeight é o tamanho da tela do cliente
      // */
      if (
        this.scrollTable(e) < 300 &&
        this.pagination.currentPage < this.pagination.lastPage
      ) {
        clearTimeout(this.timerScroll)
        this.timerScroll = setTimeout(() => {
          if (this.searching == false) {
            this.searchItem('scroll')
          }
        }, 200)
      }
    },
    scrollTable(e) {
      let elem = e.target ? e.target : e[0]
      let value = elem.scrollHeight - Math.abs(elem.scrollTop)
      let posicaoScroll = value - elem.clientHeight
      return posicaoScroll
    },
    desmarcaItemSelected(item) {
      this.selected = this.selected.filter((e) => e.CODIGO !== item.CODIGO)
    },
    selectItem(item) {
      this.selected.push(item)
      this.updateQnt(item)
    },
    updateCurrency(e) {
      this.moeda = this.currenciesList[e ? e.index : 0].index
    },
    clickLine($event) {
      this.currentList.filter((e, index) => {
        if (e.CODIGO == $event.CODIGO) {
          this.desmarcaLinha()
          this.setIndexRowSelected(index)
        }
      })
      this.updateRodapeSelect($event)
    },
    pinObject(item) {
      if (this.order.moeda !== this.moeda) {
        this.$toasted.error(
          'Moeda da consulta é diferente do orçamento. Corrigir para continuar.'
        )
        return
      }
      if (this.order.tipoPreco !== this.tipoPreco) {
        this.$toasted.error(
          'Tipo Preço da consulta é diferente do orçamento. Corrigir para continuar.'
        )
        return
      }

      item.quantidade = 1
      this.$emit('object-pin', item)
    },
    getDadosItem: function(item) {
      let dados = {
        quantidade: 0,
        totalItem: 0,
        indexMoeda0: 0,
      }
      this.orderItens.filter((e) => {
        if (item.CODIGO == e.ITEM) {
          dados.quantidade = e.QUANTIDADE ? parseInt(e.QUANTIDADE) : 0
          dados.totalItem =
            e.PRECO && e.QUANTIDADE && e.QUANTIDADE > 0
              ? e.PRECO * e.QUANTIDADE
              : 0
        }
      })
      dados.indexMoeda0 = this.currenciesList.filter((e) => e.index == 0)
      return dados
    },
    updateQnt(item, quantidade = 1) {
      let index = this.selected.findIndex((e) => item.CODIGO == e.CODIGO)
      let index1 = this.itemList.findIndex((e) => item.CODIGO == e.CODIGO)
      if (index === -1) {
        this.selectItem(item)
      } else {
        this.selected[index].quantidade = quantidade
      }
      if (index1) {
        this.itemList[index1].quantidade = quantidade
      }
    },
    getColor(oferta) {
      if (oferta === 'S') return 'green'
      else return ''
    },

    addItens() {
      this.$emit('addItens', this.selected)
    },
    prepareSearchQuery(hibrido = false) {
      this.tipoPreco = this.priceTypes[this.indexPriceTypes].value
      let obj = {
        page: this.page,
        perPage: 30,
        tipoPreco: this.indexPriceTypes,
        moedaBalcao: this.moeda,
        condicaoPgto: this.order.condicaoPgto,
        pdvBalcao: true,
        marca: this.searchItens.marca ?? null,
        fabricante: this.searchItens.fabricante ?? null,
        codigo:
          !hibrido && this.searchItens.codigo ? this.searchItens.codigo : null,
        hibrido:
          hibrido && this.searchItens.codigo ? this.searchItens.codigo : null,
      }
      return obj
    },
    async searchItem(type = 'item') {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let value = this.searchItens.codigo
          this.getDados(value == parseInt(value) ? false : true, type)
        }, 500)
      } catch (error) {
        console.log(error)
      }
    },

    async getDados(hibrido = true, type = 'item') {
      try {
        if (type === 'item') {
          this.page = 1
          this.goToTableTop()
        } else {
          this.page = this.page + 1
        }
        this.searching = true
        await this.getItemsAPI({
          query: this.prepareSearchQuery(hibrido),
          type: type,
        })
        this.itensTable = parseInt(this.itemList.length)
        this.updateRodapeSelect()
        this.searching = false
      } catch (error) {
        this.$toasted.error(error, { duration: null })
      }
    },
    updateRodapeSelect($event = null) {
      this.dadosRodape = []
      if ($event) this.dadosRodape.push($event)
      else {
        // prioridade é do currentList (lista ordenada pelo v-data-table)
        if (this.currentList && this.currentList.length > 0)
          this.dadosRodape.push(this.currentList[this.indexRowSelected])
        else if (this.itemListComputed && this.itemListComputed.length > 0)
          this.dadosRodape.push(this.itemListComputed[this.indexRowSelected])
      }
    },
    mouseOverLine(type, item) {
      this.toogleOverlay(item)
    },
    closeOverlay() {
      this.overlay.overlay = false
    },
    toogleOverlay(item = null) {
      const imagensName = ['IMAGEM', 'IMAGEM1', 'IMAGEM2', 'IMAGEM3']
      this.imagesList = []
      this.overlay.model = 0
      this.overlay.item = item
      if (item && item.imagens) {
        this.overlay.overlay = !this.overlay.overlay
        this.overlay.especificacoes = item.imagens.especificacoes
        imagensName.forEach((key) => {
          if (item.imagens.images_base64[key]) {
            let path =
              'data:image/jpg;base64,' + item.imagens.images_base64[key]
            this.imagesList.push(path)
          }
        })
      }
    },
    selectAllToggle(props) {
      if (this.selected.length > 0) {
        this.selected = []
        return
      }
      if (
        this.selected.length !=
        this.itemListComputed.length - this.disabledCount
      ) {
        this.selected = []
        const self = this
        props.items.forEach((item) => {
          if (!item.disableSelect) {
            self.selected.push(item)
          }
        })
      } else this.selected = []
    },
    updateFullScreen() {
      this.fullscreen = !this.fullscreen
    },
    updateHeightTable(breakpointName = 'lg') {
      const size = {
        default: {
          xs: '100vh',
          sm: '52vh',
          md: '50vh',
          lg: '54vh',
          xl: '64vh',
        },
        fullscreen: {
          xs: '100vh',
          sm: '64vh',
          md: '62vh',
          lg: '70vh',
          xl: '78vh',
        },
      }
      if (this.fullscreen) return size.fullscreen[breakpointName]
      else return size.default[breakpointName]
    },
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    isGuest: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style>
.focused-line {
  background-color: rgb(59, 53, 53) !important;
}
.saldo-minimo {
  color: #bd200d !important;
  font-weight: bold;
}
</style>
